module.exports = __webpack_public_path__ + "static/media/bistecca-3.463c1e0a.jpg";